(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-wholesale-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wd-wholesale-grid')) {
    customElements.define(
      'wd-wholesale-grid',
      class WholesaleGrid extends HTMLElement {
        connectedCallback() {
          this.inputs = Array.from(this.querySelectorAll('[data-variant-id]'));
          this.submitButton = this.querySelector('[data-wholesale-submit]');
          this.linesOutput = this.querySelector('[data-wholesale-lines]');
          this.unitsOutput = this.querySelector('[data-wholesale-units]');
          this.subtotalOutput = this.querySelector('[data-wholesale-subtotal]');
          this.statusOutput = this.querySelector('[data-wholesale-status]');
          if (!this.submitButton) return;

          this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency: this.dataset.currency || 'USD',
          });

          this.inputs.forEach((input) => {
            input.addEventListener('input', () => this.updateSummary());
            input.addEventListener('change', () => {
              this.normalizeQuantity(input);
              this.updateSummary();
            });
          });
          this.submitButton.addEventListener('click', () => this.addSelected());
          this.updateSummary();
        }

        normalizeQuantity(input) {
          let value = Math.max(0, Number.parseInt(input.value, 10) || 0);
          const minimum = Number.parseInt(input.dataset.min, 10) || 1;
          const step = Number.parseInt(input.dataset.step, 10) || 1;
          const maximum = input.dataset.max ? Number.parseInt(input.dataset.max, 10) : null;
          if (value > 0) {
            value = Math.max(value, minimum);
            const remainder = (value - minimum) % step;
            if (remainder) value += step - remainder;
            if (maximum !== null) {
              const maximumAllowed = maximum < minimum ? 0 : maximum - ((maximum - minimum) % step);
              value = Math.min(value, maximumAllowed);
            }
          }
          input.value = value;
        }

        selectedItems() {
          return this.inputs
            .map((input) => ({
              id: input.dataset.variantId,
              quantity: Math.max(0, Number.parseInt(input.value, 10) || 0),
              price: Number.parseInt(input.dataset.price, 10) || 0,
            }))
            .filter((item) => item.quantity > 0);
        }

        updateSummary() {
          const items = this.selectedItems();
          const units = items.reduce((sum, item) => sum + item.quantity, 0);
          const subtotal = items.reduce((sum, item) => sum + item.quantity * item.price, 0);
          this.linesOutput.textContent = `${items.length} ${this.dataset.linesLabel}`;
          this.unitsOutput.textContent = `${units} ${this.dataset.unitsLabel}`;
          this.subtotalOutput.textContent = this.money.format(subtotal / 100);
          this.submitButton.disabled = items.length === 0;
        }

        async addSelected() {
          this.inputs.forEach((input) => this.normalizeQuantity(input));
          this.updateSummary();
          const items = this.selectedItems();
          if (!items.length) {
            this.setStatus(this.dataset.emptyMessage, 'error');
            return;
          }

          this.submitButton.disabled = true;
          this.submitButton.setAttribute('aria-busy', 'true');
          const originalText = this.submitButton.textContent;
          this.submitButton.textContent = this.dataset.addingMessage;
          this.setStatus('', '');

          try {
            const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            const body = { items: items.map(({ id, quantity }) => ({ id, quantity })) };
            if (cart?.getSectionsToRender) {
              body.sections = cart.getSectionsToRender().map((section) => section.id);
              body.sections_url = window.location.pathname;
              cart.setActiveElement?.(this.submitButton);
            }

            const response = await fetch(this.dataset.cartAddUrl, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify(body),
            });
            const result = await response.json();
            if (!response.ok || result.status) {
              throw new Error(result.description || result.message || this.dataset.errorMessage);
            }

            this.inputs.forEach((input) => {
              input.value = 0;
            });
            this.updateSummary();
            this.setStatus(this.dataset.addedMessage, 'success');

            if (cart?.renderContents && result.sections) {
              try {
                const cartIcon = document.getElementById('cart-icon-bubble');
                if (cartIcon) cart.setActiveElement?.(cartIcon);
                if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
                cart.renderContents(result);
              } catch {
                window.location.href = this.dataset.cartUrl;
              }
            } else {
              window.location.href = this.dataset.cartUrl;
            }
          } catch (error) {
            this.setStatus(error.message || this.dataset.errorMessage, 'error');
          } finally {
            this.submitButton.removeAttribute('aria-busy');
            this.submitButton.textContent = originalText;
            this.submitButton.disabled = this.selectedItems().length === 0;
          }
        }

        setStatus(message, state) {
          if (!this.statusOutput) return;
          this.statusOutput.textContent = message;
          this.statusOutput.dataset.state = state;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
